import React from "react"
import Index from "../Index"
import { contentLayout, modules } from "../../config/pages"
import { useUser } from "../../contexts/UserContext"
import Forbidden from "../Forbidden"

function EditCycle (){
  const {user} = useUser()
  let view = contentLayout[modules.EditCycle]
  if(user.permissions.views.length && !user.permissions.views.join().includes(modules.EditCycle.toLowerCase())){
    view = Forbidden
  }
  return(
  <Index content={view} module={modules.EditCycle}></Index>
 )
}

export default EditCycle
